import { ConvertConversionType, ConvertTransferRequest, postConvert } from 'types/wallets'
import { generateReference } from 'utils/utils'

export const convertPayloadToTransfer = (
  payload: postConvert,
  type: ConvertConversionType,
  validityDuration?: string
): ConvertTransferRequest => {
  const originatorWalletId = payload.fromWalletLsid ?? payload.fromWallet
  const beneficiaryWalletId = payload.toWalletLsid ?? payload.toWallet

  return {
    reference: payload.reference || generateReference(),
    originator: {
      currency: payload.from,
      ...(originatorWalletId != null && { walletId: String(originatorWalletId) }),
      ...(payload.amountIn && { amount: payload.amountIn }),
    },
    beneficiary: {
      currency: payload.to,
      ...(beneficiaryWalletId != null && { walletId: String(beneficiaryWalletId) }),
      ...(payload.amountOut && { amount: payload.amountOut }),
    },
    conversion: {
      type,
      ...(validityDuration && { validityDuration }),
    },
  }
}
